import {
  GET_PETITIONS_FAILED,
  GET_PETITIONS_REQUEST,
  GET_PETITIONS_SUCCESS,
} from './actionTypes';

export const petitionsRequest = () => ({ type: GET_PETITIONS_REQUEST });
export const petitionsSuccess = (data, meta) => ({ type: GET_PETITIONS_SUCCESS, data, meta });
export const petitionsFailure = (error) => ({ type: GET_PETITIONS_FAILED, error });
